import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
    },
    mainLabel: {
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: theme.spacing(1),
    },
    label: {
      textTransform: 'capitalize',
    },
    formControl: {
      flexGrow: 1,
      width: '100%',
    },
    select: {},
    error: {
      paddingLeft: theme.spacing(3),
      paddingTop: theme.spacing(0),
      marginTop: theme.spacing(-0.5),
      color: theme.palette.error.main,
    },
  }),
);
